var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.61571 6.47095C4.54814 6.35669 4.48797 6.23853 4.43538 6.11726C4.21187 5.60194 4.12506 5.03049 4.18786 4.46355C4.26544 3.76318 4.56681 3.11061 5.04325 2.61131C5.32064 2.32072 5.65019 2.09017 6.013 1.93286C6.37582 1.77555 6.76477 1.69458 7.15759 1.69458C7.55041 1.69458 7.93936 1.77555 8.30218 1.93286C8.66499 2.09017 8.99454 2.32072 9.27193 2.61131L13.868 7.40619C14.4269 7.99451 14.7405 8.78979 14.7405 9.61868C14.7405 10.4476 14.4269 11.2429 13.868 11.8312C13.3049 12.4151 12.5437 12.7427 11.7503 12.7427C10.957 12.7427 10.1958 12.4151 9.63267 11.8312L8.17909 10.3068",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4355 13.6255C15.7618 14.2219 15.8915 14.9139 15.8046 15.5948C15.7177 16.2758 15.419 16.9081 14.9545 17.3944C14.3925 17.9778 13.6324 18.3053 12.8402 18.3053C12.0479 18.3053 11.2878 17.9778 10.7258 17.3944L6.12974 12.5925C5.57127 12.0054 5.25781 11.2113 5.25781 10.3835C5.25781 9.55576 5.57127 8.76164 6.12974 8.17451C6.69284 7.59061 7.45405 7.26294 8.24742 7.26294C9.04079 7.26294 9.80199 7.59061 10.3651 8.17451L11.8967 9.77466",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLink);
export default __webpack_public_path__ + "static/media/icon-link.697cc21a1f179a8647310417d222e996.svg";
export { ForwardRef as ReactComponent };